<template>
  <v-container>
    <v-card>
      <v-card-title>
        Test
      </v-card-title>
      <v-card-text>
        test
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "PublicTicketView"
};
</script>

<style scoped>

</style>
